import { render } from "./AddNewLabelModal.vue?vue&type=template&id=59a49228&ts=true"
import script from "./AddNewLabelModal.vue?vue&type=script&lang=ts"
export * from "./AddNewLabelModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__